import { atomWithStorage } from 'jotai/utils'
import { atomWithImmer } from 'jotai-immer'

import { INITIAL_USER_DATA } from './constants'

export const userDataAtom = atomWithImmer(INITIAL_USER_DATA)

// 邀请新人的弹窗是否手动关闭过
export const invitationActivityAtom = atomWithStorage('invitationActivity', false)
